import React, {useState, useEffect} from "react";
import axios from "axios";
import Popup from "reactjs-popup";
import NavBar from "./NavBar";
import Header from './Header';
import Header2 from './Header2';
import "./style/Table.css";

// Import API_URL from config.js
const config = require("../config");
const API_URL = config.API_URL;

const PantryCurrentInventory = ({user}) => {
    const [editedData, setEditedData] = useState([]);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [deletedOption, setDeletedOption] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);
    const [addQuantity, setAddQuantity] = useState("");

    useEffect(() => {
        fetchData();
    }, []);

    // Used to query current item inventory
    const fetchData = async () => {
        try {
            const apiUrl = `${API_URL}/items/query`;
            const response = await axios.post(apiUrl, {
                location_id: 1,
            });
            const retrievedData = response.data.map((item) => ({
                ...item,
                isEditing: false,
            }));
            setEditedData(retrievedData);
            console.log(response.data);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    // Triggers when a certain items text box is selected to be edited
    const handleEdit = (index) => {
        const updatedData = [...editedData];
        updatedData[index].isEditing = true;
        setEditedData(updatedData);
    };

    // Handles the updated value user inputted
    const handleQuantityChange = (event, index) => {
        const updatedData = [...editedData];
        updatedData[index].quantity = event.target.value;
        setEditedData(updatedData);
    };

    // Sets deleted option and opens popup menu
    const confirmDelete = (item) => {
        setDeletedOption(item);
        setIsModalOpen(true);
    }

    const lowstockNoti = async ( to, subject, text ) => {
        try {
            const request = await axios.post(`${API_URL}/items/mail`, {
                to,
                subject,
                text,
            });

            console.log("Email Sent Successfully", request.data);
        } catch (error) {
            console.error("Error sending Email", error);
        }
    };

    // Used to submit updated values and refresh page
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedRows = editedData.filter(
                (dataItem) => dataItem.isEditing
            );

            await Promise.all(
                updatedRows.map(async (dataItem) => {
                    try {
                        const response = await axios.put(
                            `${API_URL}/items/update`,
                            {
                                item_id: dataItem.item_id,
                                item_name: dataItem.item_name,
                                location_id: 1,
                                new_stock_level: dataItem.quantity,
                            }
                        );
                        console.log(
                            "Data updated successfully:",
                            response.data
                        );
                        if(dataItem.quantity <= 5) {
                            lowstockNoti("pantry.director@missouri.edu, tptclogistics@missouri.edu", "Item Low Stock", `${dataItem.item_name} currently has a stock of ${dataItem.quantity}`);
                        }
                    } catch (error) {
                        console.error("Error updating data:", error);
                    }
                })
            );

            setUpdateSuccess(true);
            setSelectedOption(null);
            setAddQuantity("");
            setTimeout(() => {
                setUpdateSuccess(false);
            }, 3000);

            fetchData(); // Refresh table data after submitting changes
        } catch (error) {
            console.error("Error:", error);
        }
    };

    // Takes input of the item whose onClick event is triggered and deletes the item
    const handleDelete = async (item) => {
        try{
            const response = await axios.delete(
                `${API_URL}/items/update/delete`,
                {
                    data: {
                        item_id: item,
                    }
                }
            );
            console.log("Item deleted successfully", response);
            setIsModalOpen(false);
            fetchData();
        }catch(error){
            console.log("error", error);
        }
    };

    return (
        <div>
            <Header />
            <Header2 />
            <NavBar user={user} />
            <h1>Pantry Current Inventory</h1>

            <div className="dynamic-box">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {editedData &&
                            editedData.map((dataItem, index) => (
                                <tr key={index}>
                                    <td>{dataItem.item_name}</td>
                                    <td onClick={() => handleEdit(index)}>
                                        {dataItem.isEditing ? (
                                            <input
                                                type="number"
                                                value={dataItem.quantity}
                                                onChange={(event) =>
                                                    handleQuantityChange(
                                                        event,
                                                        index
                                                    )
                                                }
                                            />
                                        ) : (
                                            dataItem.quantity
                                        )}
                                        <input
                                            type="hidden"
                                            value={dataItem.item_id}
                                            name={`item_id_${index}`}
                                        />
                                        <input
                                            type="hidden"
                                            value={dataItem.location_id}
                                            name={`location_id_${index}`}
                                        />
                                    </td>
                                    <td>
                                        <span
                                            style={{
                                                cursor: "pointer",
                                                color: "#F1B82D",
                                                fontSize: "27px",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                            onClick={() => confirmDelete(dataItem.item_id)}
                                        >
                                            &#x1F5D1;   
                                        </span>
                                    </td>
                                </tr>
                            ))}
                    </tbody>         
                </table>
                <button className="button-submit" onClick={handleSubmit}>
                    Submit Changes
                </button>
                {updateSuccess && <p>Update successful!</p>}
            </div>

            <Popup
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                modal
                contentStyle={{
                    background: "#f0f0f0",
                    borderRadius: "25px",
                    padding: "20px",
                    border: "solid 2px #404040",
                    color: "#262626",
                }}
                >

                <div>
                    <p style={{color: "#262626"}}>
                        Do you want to delete this item?
                    </p>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <button
                            onClick={() => handleDelete(deletedOption)}
                            style={{
                                backgroundColor: "#404040",
                                color: "#fff",
                                border: "none",
                                padding: "8px 16px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontSize: "14px",
                            }}
                        >
                            Yes
                        </button>
                        <button
                            onClick={() => setIsModalOpen(false)}
                            style={{
                                backgroundColor: "#404040",
                                color: "#fff",
                                border: "none",
                                padding: "8px 16px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontSize: "14px",
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default PantryCurrentInventory;
